import * as Sentry from '@sentry/browser'

declare global {
  interface Window {
    isDhSentryInitiated: any
  }
}

window.isDhSentryInitiated = false
if (!window.isDhSentryInitiated) {
  initSentry()
}

function initSentry() {
  Sentry.init({
    dsn: 'https://61a06075b4944857a732bd9ae155c639@sentry.io/2432586',
    sampleRate: 0.3,
  })
  window.isDhSentryInitiated = true
}
